import { ComponentClassNames } from '../../../../util/classNames';
import { getGutterValueInPixels } from '../../../../util/styles/gutters';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';

import { headerHeight } from './HeaderRow.types';

type GetClassNames = (
  mainAreaHeight: number,
  leftNavWidth: number,
  gutterSize: number
) => ComponentClassNames<'leftNavPositionWrapper' | 'scrollablePaddingWrapper'>;

export const getClassNames: GetClassNames = memoizeFunction((mainAreaHeight, leftNavWidth, gutterSize) => {
  const fallbackHeight = `calc(100vh - ${headerHeight}px)`;
  const height = mainAreaHeight || fallbackHeight;
  const scrollbarPadding = getGutterValueInPixels(gutterSize);

  return mergeStyleSets({
    leftNavPositionWrapper: {
      position: 'fixed',
      width: leftNavWidth + scrollbarPadding,
      height,
    },
    scrollablePaddingWrapper: {
      paddingTop: getGutterValueInPixels(gutterSize),
      paddingRight: scrollbarPadding,
    },
  });
});
